export default __webpack_public_path__ + "2536c5c8133e3bd71ce018f8a692a4aa.js";